import React, { useEffect } from "react";
import TranslationWrapper from "./TranslationWrapper.tsx";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { connect } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { withStyles } from "tss-react/mui";
import JamezzFormStyles from "../../views/JamezzForm/JamezzFormStyles";
import GridItem from "../Grid/GridItem";
import GridContainer from "../Grid/GridContainer";
import CloseIcon from "@mui/icons-material/Close";
import { useDialog } from "../../licensing/utils/DialogProvider.tsx";
import CustomSwitch from "../CustomInput/CustomSwitch";
import { translationMode } from "../../store/reducers/translations";

const useStyles = makeStyles()({
  actionButtons: {
    display: "flex",
    flexDirection: "column",
  },
});

const TranslationDialogSetLanguage = ({
  classes,
  translations,
  languagesToTranslate,
  updateLanguagesToTranslate,
  displayedLanguage,
  updateDisplayedLanguage,
}) => {
  const { classes: localClasses } = useStyles();
  const [, closeDialog] = useDialog();

  const languages = Object.keys(translations);
  const [translateExceptionsMode, setTranslateExpectionsMode] = React.useState(
    JSON.parse(localStorage.getItem("translateExceptionsMode")) ?? false
  );

  console.log(translateExceptionsMode);

  useEffect(() => {
    localStorage.setItem("translateExceptionsMode", translateExceptionsMode);
  }, [translateExceptionsMode]);

  const generateMenuItemsLanguages = () => {
    return languages.map((language) => (
      <MenuItem
        classes={{
          root: classes.selectMenuItem,
          selected: classes.selectMenuItemSelected,
        }}
        key={language}
        value={language}
      >
        {language}
      </MenuItem>
    ));
  };

  const updateTranslationMode = (newMode) => {
    localStorage.setItem("translationMode", newMode ? "true" : "false");
    location.reload();
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <DialogTitle id={"alert-dialog-title"}>Translation mode settings</DialogTitle>
        <div style={{ position: "absolute", top: 20, right: 20 }}>
          <CloseIcon onClick={closeDialog} />
        </div>
      </div>

      <DialogContent>
        <GridContainer>
          <GridItem xs={5}>
            <FormLabel className={classes.labelHorizontal}>Displayed</FormLabel>
          </GridItem>
          <GridItem xs={7}>
            <FormControl fullWidth>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                onChange={(e) => {
                  const languagesToTranslateCopy = [...languagesToTranslate];
                  if (languagesToTranslateCopy.every((language) => language !== e.target.value)) {
                    languagesToTranslateCopy.push(e.target.value);
                  }
                  updateDisplayedLanguage(e.target.value);
                  updateLanguagesToTranslate(languagesToTranslateCopy);
                }}
                value={displayedLanguage}
              >
                {generateMenuItemsLanguages()}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={5}>
            <FormLabel className={classes.labelHorizontal}>To translate</FormLabel>
          </GridItem>
          <GridItem xs={7}>
            <FormControl fullWidth>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                multiple
                onChange={(e) => {
                  updateLanguagesToTranslate(e.target.value);
                }}
                value={languagesToTranslate}
              >
                {generateMenuItemsLanguages()}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={5}>
            <FormLabel className={classes.labelHorizontal}>
              translate exceptions (refresh page to see translations in sidebar)
            </FormLabel>
          </GridItem>
          <GridItem className={classes.customSwitchInputGridItem} xs={7}>
            <CustomSwitch
              checked={translateExceptionsMode}
              name={"blocked"}
              onChange={() => setTranslateExpectionsMode((prevState) => !prevState)}
            />
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions classes={{ root: localClasses.actionButtons }}>
        <Button
          color={"primary"}
          onClick={() => {
            updateTranslationMode(!translationMode);
            closeDialog();
          }}
        >
          {translationMode ? (
            <TranslationWrapper tDefault={"Turn off translation mode"} tKey={"translation_mode.off"} />
          ) : null}
          {!translationMode ? (
            <TranslationWrapper tDefault={"Turn on translation mode"} tKey={"translation_mode.on"} />
          ) : null}
        </Button>
      </DialogActions>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translations: state.translations.translations,
    displayedLanguage: state.translations.displayedLanguage,
    languagesToTranslate: state.translations.languagesToTranslate,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDisplayedLanguage: (displayedLanguage) =>
      dispatch({
        type: "UPDATE_DISPLAYED_LANGUAGE",
        payload: displayedLanguage,
      }),
    updateLanguagesToTranslate: (languagesToTranslate) =>
      dispatch({
        type: "UPDATE_LANGUAGES_TO_TRANSLATE",
        payload: languagesToTranslate,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TranslationDialogSetLanguage, JamezzFormStyles));
